<div class="app-modal">
  <app-modal-header></app-modal-header>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-alias-list
      [aliasList]="aliasList"
      [control]="control"
    ></app-alias-list>
    <app-modal-footer
      excuteText="選択"
      [disabled]="form.invalid"
    ></app-modal-footer>
  </form>
</div>
